import AnalisaBarangJadiPeluang from "./AnalisaBarangJadi"

export default AnalisaBarangJadiPeluang